import { render, staticRenderFns } from "./ModalPesquisarProduto.vue?vue&type=template&id=a7516478"
import script from "./ModalPesquisarProduto.vue?vue&type=script&lang=js"
export * from "./ModalPesquisarProduto.vue?vue&type=script&lang=js"
import style0 from "./ModalPesquisarProduto.vue?vue&type=style&index=0&id=a7516478&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports